import React, { createContext, useContext, useEffect, useState } from 'react';
import dealService from '../services/dealService';

const DealsContext = createContext(null);

export const DealsProvider = ({ children }) => {
    const [deals, setDeals] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const unsubscribe = dealService.subscribeToDeals((data) => {
            setDeals(data);
            setLoading(false);
        });

        return () => {
            unsubscribe();
        };
    }, []);

    const value = {
        deals,
        loading,
        error,
    };

    return (
        <DealsContext.Provider value={value}>
            {children}
        </DealsContext.Provider>
    );
};

export const useDeals = () => {
    const context = useContext(DealsContext);
    if (!context) {
        throw new Error('useDeals must be used within a DealsProvider');
    }
    return context;
};
